module.exports = __webpack_public_path__ + "img/solowin.0ddbb13a.png";